// Applies fn to every string of a Yoast schema graph
export function mapSchemaStrings(value: unknown, fn: (s: string) => string): unknown {
  if (typeof value === "string") {
    return fn(value);
  }
  if (Array.isArray(value)) {
    return value.map((item) => mapSchemaStrings(item, fn));
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, mapSchemaStrings(val, fn)]),
    );
  }
  return value;
}

/**
 * Yoast's yoast_head_json.robots is an object of directives
 * (e.g. {index: "index", follow: "follow", "max-snippet": "max-snippet:-1"}).
 * <meta name="robots"> expects a single comma-separated string.
 */
export function getRobotsContent(robots: Record<string, string> | null | undefined) {
  if (!robots || typeof robots !== "object") {
    return null;
  }
  return Object.values(robots).filter(Boolean).join(", ");
}
